var CustomerFieldsApp = {
    version: "1.2024.05.31",
    fieldsSelector: "",
    settings: {},
    loader: '<div class="cf-app__lds-ring"><div></div><div></div><div></div><div></div></div>',
    required_span: '<span class="cf-required" title="Required">*</span>',
    fallbackForm: '<label for="FirstName">First Name</label><input type="text" name="customer[first_name]" id="FirstName" autofocus><label for="LastName">Last Name</label><input type="text" name="customer[last_name]" id="LastName"><label for="Email">Email</label><input type="email" name="customer[email]" id="Email" autocorrect="off" autocapitalize="off"><label for="CreatePassword">Password</label><input type="password" name="customer[password]" id="CreatePassword"><p class="text-center"><input type="submit" value="Submit" class="btn"></p>',
    loadScript: function(e, t) {
        var i = document.createElement("script");
        i.type = "text/javascript", i.readyState ? i.onreadystatechange = function() {
            "loaded" != i.readyState && "complete" != i.readyState || (i.onreadystatechange = null, t())
        } : i.onload = function() {
            t()
        }, i.src = e, document.getElementsByTagName("head")[0].appendChild(i)
    },
    getJQuery: function(e) {
        var t = this;
        return void 0 !== this.settings.jQuery ? t[e](t.settings.jQuery) : "undefined" == typeof jQuery || parseFloat(jQuery.fn.jquery) < 3 ? void this.loadScript("//code.jquery.com/jquery-3.3.1.min.js", function() {
            t[e](jQuery.noConflict(!0))
        }) : t[e](jQuery)
    },
    initFields: function(e, t) {
        this.fieldsSelector = e, this.settings = t, this.getJQuery("_initFields")
    },
    displayMessage: function(e, t, i, n) {
        if (t.find(".cf-app__messages").remove(), i) {
            var a = e('<div class="cf-app__messages messages--' + n + '">' + i + "</div>");
            t.prepend(a), e("body,html").animate({
                scrollTop: a.offset().top - 50
            }, 250), this.runCallback("onDisplayMessage", {
                form: t.get(0),
                message: i,
                message_type: n
            })
        }
    },
    uploadFile: function(e, t, i, n, a, s, r, o) {
        var d = this,
            l = new FileReader,
            u = i.size,
            c = 0,
            f = c + 262144,
            p = i.slice(c, f),
            m = d.settings.base_url + "apps/cf_app/api/customer_fields/v1/" + d.settings.site_id + "/upload-file/" + n + "/" + a + "/" + s;
        l.onload = function(a) {
            e.ajax({
                url: m,
                type: "POST",
                data: {
                    data: btoa(a.target.result),
                    filename: i.name
                },
                success: function(t) {
                    f = (c += 262144) + 262144, c >= u ? (r(95), e.post(m, {
                        filename: i.name,
                        is_complete: !0
                    }, function(e) {
                        r(100), setTimeout(function() {
                            o(e.file_temp_url)
                        }, 750)
                    })) : (r(c / u * 100), p = i.slice(c, f), l.readAsBinaryString(p))
                },
                error: function(i) {
                    if (void 0 !== i.responseJSON.error_type && "file_too_large" === i.responseJSON.error_type) {
                        r(0);
                        var a = e('input[data-field-id="' + n + '"]');
                        a.val(""), d.setFormErrors(e, t, [{
                            field: a.data("machine-name"),
                            error: "File is too large."
                        }])
                    } else {
                        var s = this;
                        setTimeout(function() {
                            e.ajax(s)
                        }, 2500)
                    }
                }
            })
        }, l.readAsBinaryString(p)
    },
    setUploadProgress: function(e, t) {
        t ? e.find(".cf-app__upload-progress").addClass("visible") : e.find(".cf-app__upload-progress").removeClass("visible"), e.find(".cf-app__progress-bar").css("width", t + "%")
    },
    removeFileLinkEvent: function(e) {
        "true" === e.find('input[type="file"]').attr("data-required") && (e.find('input[type="file"]').prop("required", !0), e.find('input[type="file"]').attr("data-required", null)), e.find('input[type="file"]').val(""), e.find('input[name$="[file_temp_url]"]').val(""), e.find('input[name$="[file_existing_url]"]').val(""), e.find(".cf-app__file-preview").removeClass("has-file"), e.find(".preview-file").remove()
    },
    attachAddressEvents: function(e, t) {
        var i = this,
            n = t.find('select[name$="[country]"]');
        n.data("default-value") && n.val(n.data("default-value")), i.showAddressProvinces(e, t);
        var a = t.find('select[name$="[province]"]');
        a.data("default-value") && a.val(a.data("default-value")), t.find('select[name$="[country]"]').on("change", function(n) {
            i.showAddressProvinces(e, t)
        })
    },
    showAddressProvinces: function(e, t) {
        var i = t.find('select[name$="[country]"]'),
            n = t.find('select[name$="[province]"]');
        n.val(""), n.closest(".cf-app__field").hide(), n.find("option").remove();
        var a = i.find("option:selected").attr("data-provinces");
        (a = JSON.parse(a)) && a.length && (n.append('<option value="">- select -</option>'), e.each(a, function(e, t) {
            n.append('<option value="' + t[0] + '">' + t[1] + "</option>")
        }), n.closest(".cf-app__field").show())
    },
    _initFields: function(e) {
        var t = this;
        this.settings.styles_url && e("head").append('<link rel="stylesheet" href="' + this.settings.styles_url + '" type="text/css" />');
        var i = {};
        this.settings.customer_id && (i.customer_id = this.settings.customer_id, i.api_token = this.settings.customer_token), void 0 !== this.settings.admin_token && (i.admin_token = this.settings.admin_token), void 0 !== this.settings.pos && (i.pos = this.settings.pos);
        var n = e(t.loader);
        e(t.fieldsSelector).append(n), void 0 === this.settings.version && (this.settings.version = 1), e.get(this.settings.base_url + "apps/cf_app/api/customer_fields/v" + this.settings.version + "/" + this.settings.site_id + "/fields", i, function(i) {
            n.remove(), e.each(i, function(i, n) {
                e(t.fieldsSelector).append(n.el)
            });
            var a = e(t.fieldsSelector).closest("form");
            t.attachConditions(e, a), t.attachDatePicker(e, a), a.find(".cf-app__field-type--address").length && e.each(a.find(".cf-app__field-type--address"), function(i, n) {
                t.attachAddressEvents(e, e(n))
            }), t.runCallback("onFieldsLoaded", a.get(0));
            var s = a.find('input[type="file"]');
            s.length && s.each(function(i, n) {
                var s = e(n).closest(".cf-app__field");
                s.find(".cf-app__remove-file__link").on("click", function(e) {
                    e.preventDefault(), t.removeFileLinkEvent(s)
                }), s.find('input[name*="[file_existing_url]"]').val() && s.find('input[type="file"]').get(0).required && (s.find('input[type="file"]').attr("data-required", "true"), s.find('input[type="file"]').get(0).required = !1), e(n).on("change", function(i) {
                    var r = e(n).data("field-id"),
                        o = e(n).data("timestamp"),
                        d = e(n).data("hash"),
                        l = i.currentTarget.files[0];
                    if (l) {
                        t.setUploadProgress(s, 0);
                        var u = s.find(".cf-app__file-preview-wrapper");
                        if (u.length && (u.find(".preview-file").remove(), u.find(".cf-app__file-preview").removeClass("has-file")), a.find('input[type="submit"]').attr("disabled", "disabled"), t.clearFormErrors(e, a), e(n).data("max-file-size") && l.size > e(n).data("max-file-size")) return e(n).val(""), void t.setFormErrors(e, a, [{
                            field: e(n).data("machine-name"),
                            error: "File is too large."
                        }]);
                        t.setUploadProgress(s, 1), t.uploadFile(e, a, l, r, o, d, function(e) {
                            t.setUploadProgress(s, e)
                        }, function(i) {
                            t.setUploadProgress(s, 0), s.find('input[name$="[file_temp_url]"]').val(i), e(n).get(0).required && (e(n).prop("required", !1), e(n).attr("data-required", "true")), e(n).val("");
                            var r = u.find(".cf-app__file-preview");
                            if (r.length) {
                                if (r.addClass("has-file"), "image" === e(n).data("field-type"))(o = e('<img class="preview-file preview-file--image"/>')).attr("src", i);
                                else if ("file" === e(n).data("field-type")) {
                                    var o;
                                    (o = e('<a class="preview-file preview-file--file" target="_blank">' + l.name + "</a>")).attr("href", i)
                                }
                                r.append(o), setTimeout(function() {
                                    o.addClass("visible")
                                }, 250)
                            }
                            a.find('input[type="submit"]').attr("disabled", !1), s.find(".cf-app__remove-file__link").on("click", function(e) {
                                e.preventDefault(), t.removeFileLinkEvent(s)
                            })
                        })
                    }
                })
            }), a.find("button.form-submit").on("click", function(i) {
                i.preventDefault(), a.find(".cf-app__field").each(function(t, i) {
                    e(i).is(":hidden") && e(i).find(":input").prop("required") && (e(i).find(":input").attr("required", null), e(i).find(":input").data("is-required", !0))
                }), t.submitForm(e, a, e(this))
            })
        }).fail(function(i) {
            void 0 !== i.responseJSON && "error" === i.responseJSON.status ? void 0 !== i.responseJSON.error_type && ("missing_api_token" === i.responseJSON.error_type && window.location.reload(), "pos_disabled" === i.responseJSON.error_type && t.runCallback("onPosDisabled", i)) : (e(t.fieldsSelector).append(t.fallbackForm), n.remove())
        })
    },
    submitForm: function(e, t, i) {
        var n = this,
            a = e(n.loader);
        if (!1 !== n.runCallback("validateBeforeSubmit", t.get(0))) {
            i.attr("disabled", "disabled"), i.closest(".cf-app__field").append(a), n.runCallback("beforeFormSubmit", t.get(0));
            var s = t.serializeArray();
            s = s.concat(t.find("input[type=checkbox]:not(:checked)").map(function() {
                return {
                    name: this.name,
                    value: 0
                }
            }).get()), 
            n.settings.customer_id 
                ? 
                    e.post(n.settings.base_url + "apps/cf_app/api/customer_fields/v1/" + n.settings.site_id + "/customers/update/" + n.settings.customer_id + "/" + n.settings.customer_token, s, function(s) {
                        i.attr("disabled", !1), a.remove(), n.runCallback("onUpdateCustomerSuccess", {
                            result: s,
                            form: t.get(0)
                        }), n.runCallback("onFormSubmit", t.get(0)), n.clearFormErrors(e, t), n.displayMessage(e, t, s.message, "success"), void 0 !== s.new_files && s.new_files.length && e.each(s.new_files, function(t, i) {
                            var n = e('input[name="customer[' + i.field_name + ']"]').closest(".cf-app__field");
                            n.find(".preview-file--image").length && n.find(".preview-file--image").attr("src", i.url), n.find(".preview-file--file").length && n.find(".preview-file--file").attr("href", i.url), n.find('input[name$="[file_existing_url]"]').val(i.url), n.find('input[name$="[file_temp_url]"]').val("")
                        })
                    }).fail(function(s) {
                        n.runCallback("onUpdateCustomerFailure", {
                            result: s,
                            form: t.get(0)
                        }), void 0 !== s.responseJSON.errors && n.setFormErrors(e, t, s.responseJSON.errors), void 0 !== s.responseJSON.message && n.displayMessage(e, t, s.responseJSON.message, "error"), i.attr("disabled", !1), a.remove()
                    }) 
                : e.post(n.settings.base_url + "apps/cf_app/api/customer_fields/v1/" + n.settings.site_id + "/customers/new", s, function(i) {
                        n.runCallback("onNewCustomerSuccess", {
                            result: i,
                            form: t.get(0)
                        }), n.runCallback("onFormSubmit", t.get(0)), t.find("#cf-app-customer-fields").fadeOut(1e3), i.user_has_password ? n.loginCustomer(e, t, i.success_message) : (void 0 !== i.success_message && i.success_message.length && n.displayMessage(e, t, i.success_message, "success"), void 0 !== n.settings.redirectAfterRegister && (window.location = n.runCallback("redirectAfterRegister", t.get(0))))
                    }).fail(function(s) {
                        n.runCallback("onNewCustomerFailure", {
                            result: s,
                            form: t.get(0)
                        }), void 0 !== s.responseJSON.message && n.displayMessage(e, t, s.responseJSON.message, "error"), void 0 !== s.responseJSON.errors && n.setFormErrors(e, t, s.responseJSON.errors), i.attr("disabled", !1), a.remove()
                    }), t.find(".cf-app__field").each(function(t, i) {
                        e(i).is(":hidden") && e(i).find(":input").data("is-required") && (e(i).find(":input").attr("required", ""), e(i).find(":input").data("is-required", null))
                    });
        }
    },
    attachDatePicker: function(e, t) {
        if (!this.supportsDateInput()) {
            var i = this.settings.base_url + "modules/custom/cf_app/public_assets/pikaday.js",
                n = this.settings.base_url + "modules/custom/cf_app/public_assets/moment.js",
                a = this;
            a.loadScript(n, function() {
                a.loadScript(i, function() {
                    e('[data-toggle="datepicker"]').each(function(t, i) {
                        var n = new Pikaday({
                            field: i,
                            format: "YYYY-MM-DD"
                        });
                        e(i).attr("placeholder", "YYYY-MM-DD"), e(i).attr("min") && n.setMinDate(new Date(e(i).attr("min"))), e(i).attr("max") && n.setMaxDate(new Date(e(i).attr("max")))
                    })
                })
            })
        }
    },
    supportsDateInput: function() {
        var e = document.createElement("input");
        return e.setAttribute("type", "date"), "date" == e.type
    },
    runCallback: function(e, t) {
        if (void 0 !== this.settings[e]) return this.settings[e](t)
    },
    loginCustomer: function(e, t, i) {
        var n = this,
            a = {
                form_type: "customer_login",
                utf8: "âœ“",
                customer: {
                    email: t.find('input[name="customer[email]"]').val(),
                    password: t.find('input[name="customer[password]"]').val()
                }
            };
        e.post("/account/login", e.param(a), function(e) {
            n.runCallback("beforeUserLoginRedirect", {
                result: e,
                form: t.get(0)
            }), void 0 !== n.settings.redirectAfterRegister ? window.location = n.runCallback("redirectAfterRegister", t.get(0)) : window.location = "/collections/professional"
        }).fail(function(a, s, r) {
            window.location = "/collections/professional"
        })
    },
    clearFormErrors: function(e, t) {
        t.find(".cf-app__field").removeClass("form-error"), t.find(".form-error-message").remove()
    },
    setFormErrors: function(e, t, i) {
        var n = this;
        this.clearFormErrors(e, t), e.each(i, function(i, a) {
            if (void 0 !== a.child_field && "" !== a.child_field) var s = e('[data-wrapper-for="' + a.field + '"] :input[name*="' + a.child_field + '"]', t).closest(".cf-app__field");
            else s = e('[data-wrapper-for="' + a.field + '"]', t);
            s.addClass("form-error"), s.find(".form-error-message").remove(), n.runCallback("onFieldError", a), a.error && s.append('<div class="form-error-message">' + a.error + "</div>")
        })
    },
    attachConditions: function(e, t) {
        var i = this;
        t.find("[data-conditions]").each(function(t, n) {
            if (e(n).attr("data-conditions")) {
                var a = JSON.parse(e(n).attr("data-conditions"));
                e.each(a, function(t, a) {
                    i.attachConditionToField(e, e(n).closest(".cf-app__field"), a)
                })
            }
        })
    },
    decodeHtml: function(e) {
        var t = document.createElement("textarea");
        return t.innerHTML = e, t.value
    },
    attachConditionToField: function(e, t, i) {
        var n = e('.cf-app__field [data-field-id="' + i.settings.field + '"]');
        this.attachCondition(e, i.type, t, n, i.settings)
    },
    getConditionEvent: function(e) {
        return e.is("input") || e.is("textarea") ? "radio" === e.attr("type") || "checkbox" === e.attr("type") ? "change" : "keyup" : e.is("select") ? "change" : void 0
    },
    getFieldValue: function(e, t) {
        return "radio" === t.attr("type") ? t.filter(":checked").length ? t.filter(":checked").val() : "" : "checkbox" === t.attr("type") ? t.filter(":checked").length ? e.map(t.filter(":checked"), function(t) {
            return e(t).val()
        }).join("|||") : "" : t.val()
    },
    attachCondition: function(e, t, i, n, a) {
        var s = this;
        n.on(this.getConditionEvent(n), function(r) {
            s["setConditionalState_" + t](e, i, s.getFieldValue(e, n), a)
        }), s["setConditionalState_" + t](e, i, s.getFieldValue(e, n), a)
    },
    setConditionalState_visible_if: function(e, t, i, n) {
        this.conditionIsTrue(n.condition, i, n) ? t.show() : t.hide()
    },
    setConditionalState_hidden_if: function(e, t, i, n) {
        this.conditionIsTrue(n.condition, i, n) ? t.hide() : t.show()
    },
    setConditionalState_required_if: function(e, t, i, n) {
        this.conditionIsTrue(n.condition, i, n) ? (t.find(':input:not([data-never-require="true"])').filter(":visible").attr("required", ""), this.addRequiredSpan(e, t)) : (t.find(":input").attr("required", null), this.removeRequiredSpan(e, t))
    },
    addRequiredSpan: function(e, t) {
        var i = t.find("label");
        if (!i.find("span.cf-required").length) {
            var n = e(this.required_span);
            i.append(n)
        }
    },
    removeRequiredSpan: function(e, t) {
        t.find("label span.cf-required").remove()
    },
    setConditionalState_not_required_if: function(e, t, i, n) {
        this.conditionIsTrue(n.condition, i, n) ? (t.find(":input").attr("required", null), this.removeRequiredSpan(e, t)) : (t.find(':input:not([data-never-require="true"])').filter(":visible").attr("required", ""), this.addRequiredSpan(e, t))
    },
    setConditionalState_disabled_if: function(e, t, i, n) {
        this.conditionIsTrue(n.condition, i, n) ? t.find(":input").attr("disabled", "") : t.find(":input").attr("disabled", null)
    },
    setConditionalState_enabled_if: function(e, t, i, n) {
        this.conditionIsTrue(n.condition, i, n) ? t.find(":input").attr("disabled", null) : t.find(":input").attr("disabled", "")
    },
    inArray: function(e, t) {
        return t.indexOf(e) > -1
    },
    conditionIsTrue: function(e, t, i) {
        if (!this.inArray(e, ["equals_any", "equals_none", "contains_any", "contains_none"])) return this._conditionIsTrue(e, t, i.value);
        for (var n = i.long_value.split("\n"), a = 0; a < n.length; a++) n[a] = n[a].trim();
        if (-1 !== e.indexOf("_any")) {
            for (a = 0; a < n.length; a++)
                if (this._conditionIsTrue(e, t, n[a])) return !0;
            return !1
        }
        if (-1 !== e.indexOf("_none")) {
            for (a = 0; a < n.length; a++)
                if (this._conditionIsTrue(e, t, n[a])) return !1;
            return !0
        }
    },
    _conditionIsTrue: function(e, t, i) {
        if (-1 !== e.indexOf("_any") || -1 !== e.indexOf("_none")) {
            for (var n = t.split("|||"), a = 0; a < n.length; a++)
                if (this.__conditionIsTrue(e, n[a], i)) return !0;
            return !1
        }
        return this.__conditionIsTrue(e, t, i)
    },
    __conditionIsTrue: function(e, t, i) {
        switch (e) {
            case "contains":
            case "contains_any":
            case "contains_none":
                return i = i || "", -1 !== (t = t || "").toLowerCase().indexOf(i.toLowerCase());
            case "not_contains":
                return i = i || "", -1 === (t = t || "").toLowerCase().indexOf(i.toLowerCase());
            case "not_empty":
                return i = i || "", "" !== (t = t || "");
            case "empty":
                return "" == (t = t || "");
            case "equals":
            case "equals_any":
            case "equals_none":
                return i = i || "", (t = t || "").toLowerCase() === i.toLowerCase();
            case "not_equals":
                return i = i || "", (t = t || "").toLowerCase() !== i.toLowerCase();
            case "gt":
                return t = t || 0, i = i || 0, parseFloat(t) > parseFloat(i);
            case "gte":
                return t = t || 0, i = i || 0, parseFloat(t) >= parseFloat(i);
            case "lt":
                return t = t || 0, i = i || 0, parseFloat(t) < parseFloat(i);
            case "lte":
                return t = t || 0, i = i || 0, parseFloat(t) <= parseFloat(i)
        }
    }
};